import { render, staticRenderFns } from "./WouldGetVaccinated.vue?vue&type=template&id=fe98abb2&"
import script from "./WouldGetVaccinated.vue?vue&type=script&lang=js&"
export * from "./WouldGetVaccinated.vue?vue&type=script&lang=js&"
import style0 from "./WouldGetVaccinated.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports